module.exports = __webpack_public_path__ + "static/media/17.57889fc7.jpg";